var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.4592 3.54036C14.7131 3.7942 14.7131 4.20575 14.4592 4.45959L6.45923 12.4596C6.20539 12.7134 5.79383 12.7134 5.53999 12.4596L1.53999 8.4596C1.28615 8.20575 1.28615 7.7942 1.53999 7.54036C1.79383 7.28652 2.20539 7.28652 2.45923 7.54036L5.99961 11.0807L13.54 3.54036C13.7938 3.28652 14.2054 3.28652 14.4592 3.54036Z","fill":"currentColor"}));
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Check;

Check.default = Check;
